import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-NKJXCB',
        },
    },
    host: 'www.zalando-lounge.pl',
});
